<script setup lang="ts">
import {ExtendedUser, WebSession} from "@/types";
import BaseLayout from "@/layouts/BaseLayout.vue";
import ProfileLayout from "@/Pages/settings/layouts/ProfileLayout.vue";
import {Head} from "@inertiajs/vue3";

interface Props {
    user: ExtendedUser,
    sessions: Array<WebSession>
}

const props = defineProps<Props>()
defineOptions({
    layout: BaseLayout
})
</script>

<template>
    <Head title="Web sessions" />
    <profile-layout
        :user="props.user"
    >
        <h1 class="font-weight-medium text-h5 mt-5">
            Web sessions
        </h1>
        <v-divider class="my-5" />
        <v-list
            class="bg-grey-lighten-4"
            rounded="lg"
            border="sm"
        >
            <v-list-item
                v-for="(session, index) in sessions"
                :key="session.ip_address"
                :class="index < sessions.length - 1 ? 'border-b' : null"
                :slim="true"
                class="py-4"
            >
                <template
                    #prepend
                >
                    <v-tooltip
                        location="bottom"
                        content-class="bg-grey-darken-4 rounded-lg text-body-2"
                        max-height="32"
                    >
                        <template #activator="{ props: attrs }">
                            <v-icon
                                v-bind="attrs"
                                size="32"
                            >
                                {{ session.agent.is_desktop ? 'mdi-monitor' : 'mdi-cellphone' }}
                            </v-icon>
                        </template>
                        {{ session.agent.browser }} on {{ session.agent.platform }}
                    </v-tooltip>
                </template>
                <v-list-item-title class="text-grey-darken-2 font-weight-bold text-body-2">
                    {{ session.ip_address }}
                </v-list-item-title>
                <v-list-item-subtitle>
                    {{ session.is_current_device ? 'You current session' : `Last accessed ${session.last_active}` }}
                </v-list-item-subtitle>
            </v-list-item>
        </v-list>
    </profile-layout>
</template>

<style scoped>

</style>
